/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-05-25 17:45:06
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Page, Layout, Card, Button, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import MainMenu from 'src/components/containers/main-menu';
import EditModal from './modal';
// import TryNewVersion from 'src/components/views/merchandising/try-new-version';

import { NUMBER_PRODUCT_VISIBILITY_RULES } from 'src/constants/product-visibility';
import { URL } from 'src/constants/links';
import DidYouKnow from 'src/components/views/product-visibility/did-you-know';
import TryNewVersion from 'src/components/containers/common/switchNewVersion/merchandising/try-new-version.jsx';
import ListProductVisibilityRules from 'src/components/views/product-visibility/list-product-visibility-rules';
import ExceededPlanNotification from 'src/components/containers/common/exceeded-plan-notifications';
import YoutubeModal from 'src/components/views/common/youtube-modal';

import { routes } from 'src/routes';
import * as commonActions from 'actions/common-actions';
import * as merchandisingV2Actions from 'src/stores/actions/merchandising-v2-actions';
import * as FilterDataActions from 'actions/filter-data-actions';
import * as productVisibilityActions from 'src/stores/actions/product-visibility-actions';
import { updateTenantApp } from 'actions/oauth-actions';
import TitleHelp from 'src/components/views/common/title-help';

type Props = {
  getProductVisibilityRules: () => void,
  updateProductVisibilityRules: () => void,
  productVisibilityRules: Array<Object>,
  loading: boolean,
  saving: boolean,
  success: boolean
};

type ComposedProps = Props & WithI18nProps;

type State = {
  selectedId: number,
  activeModalEdit: boolean,
  youtubeModal: boolean
};

class ProductVisibility extends Component<ComposedProps, State> {
  state = {
    selectedId: -1,
    activeModalEdit: false,
    youtubeModal: false
  };

  async componentDidMount() {
    const { getFilterData, getProductVisibilityRules } = this.props;
    getFilterData();
    getProductVisibilityRules();
  }

  componentWillReceiveProps(nextProps) {
    const { migrateStatus, getStatusMigrate } = nextProps;

    if (migrateStatus === 'running') {
      clearTimeout(this.timeOutGetStatus);
      this.timeOutGetStatus = setTimeout(() => {
        getStatusMigrate();
      }, 3000);
    }
  }
  render() {
    const {
      i18n,
      loading,
      saving,
      success,
      productVisibilityRules,
      getStatusMigrate,
      migrateNewFeatureV2,
      migrateStatus,
    } = this.props;
    const { youtubeModal } = this.state;

    // Check having product visibility
    const hasProductVisibility = !_.isEmpty(productVisibilityRules);

    return (
      <div className="BC-Page BC-Page__Product-Visibility">
        <MainMenu menuId="menu-merchandising-product-visibility" />
        <Page
          title={i18n.translate('AdminHTML.ProductVisibility.ProductVisibility.title')}
          primaryAction={
            <div className="BC-Page BC-Page__Button">
              {/* WARN: PFSN-30966 Hide switch merchandising - comment for hide - enable later*/}
            </div>
          }>
          <TitleHelp
            i18n={i18n}
            onPlay={() => this.toggleModal('youtubeModal')}
            hrefUserManual={URL['Link_V2_Merchandising_ProductVisibility_ManualGuide']}
          />
          <Layout>
            <Layout.Section>
              <div className="BC-Container__Notifications">
                {/* WARN: PFSN-30966 Hide switch merchandising - comment for hide - enable later*/}
                {/* //  New feature0423: old customer flow  */}
                {/* Try new version */}
                <TryNewVersion
                  migrateNewFeatureV2={migrateNewFeatureV2}
                  getStatusMigrate={getStatusMigrate}
                  migrateStatus={migrateStatus}
                  enableMerchandisingV2={this.enableMerchandisingV2}
                />
                {/* Did you know? */}
                <DidYouKnow />

                {/* Sticky notification for exceeded plan */}
                <ExceededPlanNotification />
              </div>
            </Layout.Section>

            {/* List of product visibility */}
            <Layout.Section>
              <Card>
                <Card.Section>
                  <ListProductVisibilityRules
                    key={'list-product-visibility'}
                    loading={loading}
                    list={productVisibilityRules}
                    updateProductVisibilityRules={this.props.updateProductVisibilityRules}
                    saving={saving}
                    success={success}
                    handleActiveModalEdit={this.handleActiveModalEdit}
                  />

                  {hasProductVisibility &&
                  productVisibilityRules.length < NUMBER_PRODUCT_VISIBILITY_RULES ? (
                    <div className="addNew">
                      <Button plain onClick={() => this.handleActiveModalEdit(-1)}>
                        {i18n.translate('AdminHTML.ProductVisibility.ProductVisibility.addNew')}
                      </Button>
                    </div>
                  ) : (
                    ''
                  )}
                </Card.Section>
              </Card>

              {hasProductVisibility &&
                productVisibilityRules.length >= NUMBER_PRODUCT_VISIBILITY_RULES && (
                  <div className="BC-Page BC-Page__Bottom-Text">
                    <TextStyle>
                      <TextStyle variation="negative">
                        <TextStyle variation="strong">
                          {i18n.translate('AdminHTML.Common.Title.notice')}
                        </TextStyle>
                      </TextStyle>
                      {i18n.translate('AdminHTML.ProductVisibility.ProductVisibility.reachedLimit')}
                    </TextStyle>
                  </div>
                )}
            </Layout.Section>
          </Layout>

          {/* Create/Edit modal */}
          <EditModal
            active={this.state.activeModalEdit}
            handleChange={this.handleActiveModalEdit}
            selectedId={this.state.selectedId}
          />
        </Page>
        <YoutubeModal
          active={youtubeModal}
          embeddedURL={URL['Link_V2_Merchandising_ProductVisibility_Video']}
          onClose={() => this.toggleModal('youtubeModal')}
          title={i18n.translate('AdminHTML.ProductVisibility.ProductVisibility.youtubeModal_Title')}
        />
      </div>
    );
  }

  handleActiveModalEdit = index => {
    const { activeModalEdit } = this.state;

    if (activeModalEdit) {
      this.setState({ activeModalEdit: !activeModalEdit, selectedId: -1 });
    } else {
      this.setState({ activeModalEdit: !activeModalEdit, selectedId: index });
    }
  };

  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };

  enableMerchandisingV2 = value => {
    const { enableMerchandisingV2, history } = this.props;

    enableMerchandisingV2(value);
    history.push(routes.merchandising.view());
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  migrateNewFeatureV2: () => dispatch(commonActions.migrateNewFeatureV2(ownProps.i18n)),
  getStatusMigrate: () => dispatch(commonActions.getStatusMigrate(ownProps.i18n)),
  enableMerchandisingV2: enable =>
    dispatch(merchandisingV2Actions.enableMerchandisingV2(enable, ownProps.i18n)),

  getFilterData: type => dispatch(FilterDataActions.getFilterData(ownProps.i18n)),
  getProductVisibilityRules: () =>
    dispatch(productVisibilityActions.getProductVisibilityRules(ownProps.i18n)),
  updateProductVisibilityRules: productVisibilityRules =>
    dispatch(
      productVisibilityActions.updateProductVisibilityRules(productVisibilityRules, ownProps.i18n)
    ),
  updateTenantApp: (body, meta) => dispatch(updateTenantApp(body, meta, ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  const tenantId = _.get(state.oauth, 'tenantApp.tenantId', '');
  return {
    tenantId,
    migrateStatus: _.get(state.common, 'status', null),
    productVisibilityRules: _.get(state.productVisibility, 'productVisibilityRules', []),
    loading: _.get(state.productVisibility, 'loading', false),
    saving: _.get(state.productVisibility, 'saving', false),
    success: _.get(state.productVisibility, 'success', false),
    updateTenantAppLoading: _.get(state.oauth, 'loadingUpdate', false),
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ProductVisibility));
